import React, { useState } from "react";
import { emailsStyle } from "./emailsStyle";
import _ from "lodash";
import Email from "./Email";
import ButtonLoading from "../Button/ButtonLoading";
import ContentBox from "../ContentBox/ContentBox";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../services/ReactQuery/reactQueryService";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { Box } from "@mui/material";
import { EmailMessage } from "../../types/EmailMessage";
import { ProductUnion } from "../../types/ProductUnion";

type EmailsProps = {
  product: ProductUnion;
};

const Emails = ({ product }: EmailsProps) => {
  const [emailDisplayCount, setEmailDisplayCount] = useState(3);
  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();

  let emailFilters: Record<string, any> = {
    backofficeCase: product.backofficeCase["@id"],
  };

  if (currentUser.isExternal) {
    emailFilters.hiddenExternally = false;
  }

  const queryKey = queryKeys.collection("email_messages", emailFilters);

  const { data: emails, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: () => fetchCollection("email_messages", emailFilters),
    enabled: !!product
  });

  const refetchEmails = async () => {
    await queryClient.invalidateQueries({
      queryKey: queryKey
    });
  };

  if (!emails || isLoading) {
    return null;
  }

  const displayedEmails: EmailMessage[] = _.slice(emails["hydra:member"], 0, emailDisplayCount);
  return (
    <>
      <Box sx={emailsStyle.scrollToAnchor} id={"mails"} />
      <ContentBox headline="E-Mails">
        {displayedEmails.length > 0 ? (
          _.map(displayedEmails, (emailMessage, index) => (
            <Box key={index} sx={{
              margin: "2rem 0 0 0"
            }}>
              <Email emailMessage={emailMessage} refetchEmails={refetchEmails} product={product} />
            </Box>
          ))
        ) : (
          <Box sx={emailsStyle.noMails}>Es sind noch keine Mails vorhanden</Box>
        )}
        {emails["hydra:totalItems"] > emailDisplayCount && (
          <ButtonLoading onClick={() => setEmailDisplayCount(emailDisplayCount + 10)} sx={emailsStyle.button}>
            Mehr anzeigen
          </ButtonLoading>
        )}
        {displayedEmails.length > 3 && (
          <ButtonLoading onClick={() => setEmailDisplayCount(3)} sx={emailsStyle.button}>
            Weniger anzeigen
          </ButtonLoading>
        )}
      </ContentBox>
    </>
  );
};

export default Emails;
